import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value.trim();
    if (honeypot) return;

    const statusEl = document.getElementById('contact-form-status');
    if (statusEl) {
      statusEl.textContent = '正在发送...';
      statusEl.className = 'text-sm text-foreground-500 mt-3 text-center';
    }

    try {
      const formData = new FormData(form);
      formData.delete('phone_alt');

      const response = await fetch('https://readdy.ai/api/form/d9leat8bdkpk99j7fvd0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        if (statusEl) {
          statusEl.textContent = '发送成功！我们会尽快回复你。';
          statusEl.className = 'text-sm text-green-600 mt-3 text-center';
        }
        form.reset();
      } else {
        throw new Error(parsed?.meta?.message || '发送失败');
      }
    } catch (err: unknown) {
      if (statusEl) {
        const msg = err instanceof Error ? err.message : '发送失败';
        statusEl.textContent = msg;
        statusEl.className = 'text-sm text-red-500 mt-3 text-center';
      }
    }
  };

  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {contactData.desc}
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <form
            id="contact-form"
            data-readdy-form="true"
            onSubmit={handleSubmit}
            className="space-y-4"
          >
            <input
              type="text"
              name="phone_alt"
              className="hp-field"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                你的称呼
              </label>
              <input
                type="text"
                id="contact-name"
                name="name"
                required
                className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                placeholder="请输入你的称呼"
              />
            </div>

            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                电子邮箱
              </label>
              <input
                type="email"
                id="contact-email"
                name="email"
                required
                className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                placeholder="请输入你的邮箱地址"
              />
            </div>

            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容
              </label>
              <textarea
                id="contact-message"
                name="message"
                rows={4}
                required
                maxLength={500}
                className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                placeholder="请输入你想说的话（最多500字）"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full px-6 py-3 rounded-lg bg-primary-500 text-white text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              发送留言
            </button>

            <div id="contact-form-status"></div>
          </form>

          <div className="mt-6 text-center">
            <p className="text-xs text-foreground-500">{contactData.tips}</p>
          </div>
        </div>
      </div>
    </section>
  );
}